import type { DependencyContainer } from 'tsyringe';
import { IAnalyticsGatewayToken } from '@/shared/analytics/AnalyticsGateway';
import { OlapAnalyticsGateway } from '@/shared/analytics/OlapAnalyticsGateway';

/**
 * Binds the analytics gateway token to the live OLAP gateway, which posts the
 * declarative query model to telemetry's analytics endpoints and lets the service
 * compile the SQL.
 */
export function registerAnalytics(container: DependencyContainer): void {
    container.register(IAnalyticsGatewayToken, { useClass: OlapAnalyticsGateway });
}
